module.exports = __webpack_public_path__ + "img/logo.9070d17f.png";